import React from 'react';

const SimpleTitle = ({ title, variant ,position}) => {
  return (
    <div className={`simpletitle-container ${variant} ${position} `}>
        <div className="title ">
            <h2 className="content">{title}</h2> 
        </div>
    </div>
  );
};

export default SimpleTitle;